import dealerFiltersConfig from '@/apps/dealer/filtersConfig';
import hqFiltersConfig from '@/apps/hq/filtersConfig';
import { format } from '@/utils';

import WidgetMode from './WidgetMode';

type Props = {
	baseFilterIds: string[];
	selectedFilters: {
		[k: string]: any;
	}
	location?: {
		city?: string;
		dealerOffice?: string;
		dealer?: string;
	}
};

const parseFilters = ({
	baseFilterIds,
	selectedFilters,
	location
}: Props) => {
  	const isDealerMode = WidgetMode.isDealerMode();

	const filtersConfig = isDealerMode ? dealerFiltersConfig : hqFiltersConfig;

	const baseFilterValue = baseFilterIds.reduce<undefined | string>((acc, id) => {
		if (typeof selectedFilters[id] === 'undefined') return acc;      
		let value = selectedFilters[id];
		if (id === filtersConfig.price.id) {
			value = `${format.price(value?.[0] ?? 0)} — ${format.price(value?.[1] ?? 0)} руб.`;
		}
		return acc ? `${acc}, ${value}`: String(value);
	}, undefined);

	let locationFilterValue;

	if (isDealerMode) {
		locationFilterValue = location?.dealerOffice;
	} else {
		const locationValue = [location?.city, location?.dealer, location?.dealerOffice].filter((v) => v);
		locationFilterValue = locationValue.join(', ');
	}

	return {
		baseFilterValue,
		locationFilterValue,
	};
};

export default parseFilters;